/*
  页面路由
*/

import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { user, ACCOUNT_TYPE } from '@/core/utils';

import Home from '@/pages/Home.vue';
import Project from '@/pages/Project.vue';
import Demand from '@/pages/Demand.vue';
import Investor from '@/pages/Investor.vue';
import Client_home from '@/pages/ClientHome/home.vue';



Vue.use(VueRouter);

const routes = [
  {
    path: '/home', redirect: '/'
  },

  //  若璞和bc共用， 切换不同的home显示不同的页面


  //纾困
  // {
  //   path: '/', name:'home' , component: Home,
  // },
  //OA

  {
    path: '/', name:'home' , component: Client_home,
  },
  {
    path: '/project', name:'project' , component: Project,
  },
  {
    path: '/demand', name:'demand' , component: Demand,
  },
  {
    path: '/investor', name:'investor' , component: Investor,
  },
]

export default new VueRouter({
  mode: 'history',
  routes
});
